import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { ILiabilityWaiver } from "pages/secure/facility/settings/liabilityWaivers/LiabilityWaivers";

interface IGetLiabilityWaivers {
  id?: number;
}

interface IPutLiabilityWaiver {
  id: number;
  title?: string;
  content?: string;
}

export interface IPostLiabilityWaiver {
  title: string;
  content: string;
}

interface IDeleteLiabilityWaiver {
  id: number;
}

export async function GetLiabilityWaivers(params: IGetLiabilityWaivers, useGlobalLoader?: boolean) {
  return await APIGet<ILiabilityWaiver[]>(APIUrl(AdminType.FacilityAdmin, "/facility/waiver"), params, useGlobalLoader);
}

export async function PutLiabilityWaiver(params: IPutLiabilityWaiver, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/waiver"), params, useGlobalLoader);
}

export async function PostLiabilityWaiver(params: IPostLiabilityWaiver, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/waiver"), params, useGlobalLoader);
}

export async function DeleteLiabilityWaiver(params: IDeleteLiabilityWaiver, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/waiver"), params, useGlobalLoader);
}

interface IPrintLiabilityWaiver {
  id: number;
  customer_id: number;
  tee_time_id: number;
}
export async function PrintLiabilityWaiver(
  params: IPrintLiabilityWaiver,
  useGlobalLoader?: boolean,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/waiver/print"), params, useGlobalLoader);
}
